module.exports = __webpack_public_path__ + "static/media/banner_bg.e576862a.svg";